// REMOVE WHEN NEW NAMED IMPORT WILL BE ADDED
// eslint-disable-next-line import/prefer-default-export
export const MOSCOW_HOURS_OFFSET = 3;
